import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  tabPanel: {
    padding: '45px 84px !important',
  },
});
export default useStyles;
